var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getButtonProps } from './button-props';
import { getButtonContent } from './button.content';
import { setTextColor } from '../generators/style';
import { theme as rootTheme } from '../theme';
import classNames from 'classnames';
function getTheme(_a) {
    var _b = _a.theme, theme = _b === void 0 ? 'normal' : _b, props = __rest(_a, ["theme"]);
    if (props.noneTheme)
        return props;
    if (props.normalTheme)
        theme = 'normal';
    if (props.actionTheme)
        theme = 'action';
    if (props.errorTheme)
        theme = 'error';
    if (props.cancelTheme)
        theme = 'cancel';
    if (theme === 'normal')
        props = __assign(__assign({}, rootTheme.current.ButtonProps.base), props);
    else if (theme === 'action')
        props = __assign(__assign(__assign({}, rootTheme.current.ButtonProps.base), rootTheme.current.ButtonProps.action), props);
    else if (theme === 'error')
        props = __assign(__assign(__assign({}, rootTheme.current.ButtonProps.base), rootTheme.current.ButtonProps.error), props);
    else if (theme === 'cancel')
        props = __assign(__assign(__assign({}, rootTheme.current.ButtonProps.base), rootTheme.current.ButtonProps.cancel), props);
    return props;
}
export var Button = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    props = getTheme(props);
    if (!props.letterSpacing)
        props.letterSpacing = 'wide';
    if (!!props.color && !props.textColor)
        props.textColor = 'white';
    if (!props.textColor && !props.hoverTextColor)
        props.hoverTextColor = 'surface-9';
    var _b = React.useState(0), stateMinWidth = _b[0], setMinWidth = _b[1];
    if (stateMinWidth)
        props.minWidth = stateMinWidth;
    var forwardRef = React.useRef(null);
    React.useEffect(function () { if (ref) {
        if (typeof ref === "function") {
            ref(forwardRef.current);
        }
        else {
            ref.current = forwardRef.current;
        }
    } }, [ref, forwardRef]);
    React.useEffect(function () {
        var _a;
        if (!props.loading && typeof props.loading !== 'undefined') {
            setMinWidth((_a = forwardRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth);
        }
    }, [props.loading]);
    if (typeof props.show !== 'undefined')
        props.hidden = !props.show;
    if (props.hidden)
        return null;
    setTextColor(props);
    var baseProps = getButtonProps(props, forwardRef);
    var content = getButtonContent(children, props);
    return _jsx("button", __assign({}, baseProps.props, { className: classNames('__button', (props.reactLink || props.legacyLink) ? 'a' : '', baseProps.classes), style: baseProps.styles, ref: forwardRef, disabled: props.disabled || props.loading }, { children: content }));
});
